<div
    class="modal fade"
    id="contactUs"
    tabindex="-1"
    role="dialog"
    aria-labelledby="contactUsLabel"
    aria-hidden="true"
>
    <div
        class="modal-dialog modal-dialog-scrollable"
    >
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="block-title">
                    {{"AUTO_DRAW.RESULT.CONTACT.TITLE" | translate}}
                </h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" #closeModalBtn></button>
            </div>
            <div class="modal-body">
                <!-- 參數備註 -->
                <div class="mb-4">
                    <h5>{{ 'AUTO_DRAW.RESULT.CONTACT.PARAMS' | translate }}</h5>
                    <div>
                        <ng-container *ngFor="let tim of project.tims; let idx=index">
                            <div class="d-flex justify-content-between">
                                <p>
                                    <span>{{ 'AUTO_DRAW.RESULT.CONTACT.PARAM' | translate }}</span>
                                    <span>{{tim.number}}</span>
                                </p>
                                <p class="memo-icon" (click)="memoStatusList[idx] = !memoStatusList[idx]">
                                    <i class="bi bi-pencil-square"></i>
                                </p>
                            </div>
                            <div
                                class="memo-block mb-3"
                                [ngClass]="{
                                    'memo-show': memoStatusList[idx],
                                    'memo-close': !memoStatusList[idx]
                                }"
                            >
                                <!-- 圖號 -->
                                <div class="">
                                    <textarea 
                                        class="form-control"
                                        rows="3"
                                        [placeholder]="'PLACEHOLDER.TEXT' | translate"
                                        style="max-height: 200px;"
                                        [(ngModel)]="tim.memo"
                                    ></textarea>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <!-- 基本資訊 -->
                <div class="row">
                    <h5>{{ 'AUTO_DRAW.RESULT.CONTACT.INFO' | translate }}</h5>
                    <!-- 公司名稱 -->
                    <div class="col-12 mb-3">
                        <label>
                            <span>{{ "AUTO_DRAW.ENUM.PROJECT_KEY.COMPANY_NAME" | translate }}</span>
                            <span class="text-danger">*</span>
                        </label>
                        <div class="d-flex align-items-end">
                            <input 
                                type="text" 
                                class="form-control mr-1" 
                                [placeholder]="'PLACEHOLDER.TEXT' | translate"
                                [(ngModel)]="project.company_name"
                            >
                        </div>
                    </div>
                    <!-- 聯絡人姓名 -->
                    <div class="col-12 mb-3">
                        <label>
                            <span>{{ "AUTO_DRAW.ENUM.PROJECT_KEY.APPLICANT_NAME" | translate }}</span>
                            <span class="text-danger">*</span>
                        </label>
                        <div class="d-flex align-items-end">
                            <input 
                                type="text" 
                                class="form-control mr-1" 
                                [placeholder]="'PLACEHOLDER.TEXT' | translate"
                                [(ngModel)]="project.applicant_name"
                            >
                        </div>
                    </div>
                    <!-- email -->
                    <div class="col-12 mb-3">
                        <label>
                            <span>{{ "AUTO_DRAW.ENUM.PROJECT_KEY.EMAIL" | translate }}</span>
                            <span class="text-danger">*</span>
                        </label>
                        <div class="d-flex align-items-end">
                            <input 
                                type="text" 
                                class="form-control mr-1" 
                                [placeholder]="'PLACEHOLDER.TEXT' | translate"
                                [(ngModel)]="project.applicant_email"
                            >
                        </div>
                    </div>
                    <!-- 電話 -->
                    <div class="col-12 mb-3">
                        <label>
                            <span>{{ "AUTO_DRAW.ENUM.PROJECT_KEY.PHONE" | translate }}</span>
                            <span class="text-danger">*</span>
                        </label>
                        <div class="d-flex align-items-end">
                            <input 
                                type="text" 
                                class="form-control mr-1" 
                                [placeholder]="'PLACEHOLDER.NUMBER' | translate"
                                [(ngModel)]="project.applicant_phone"
                                appOnlyNumbers
                            >
                        </div>
                    </div>
                    <!-- 國家地區 -->
                    <div class="col-6 mb-3">
                        <label>{{ "AUTO_DRAW.ENUM.PROJECT_KEY.COUNTRY" | translate }}</label>
                        <div class="d-flex align-items-end">
                            <input 
                                type="text" 
                                class="form-control mr-1" 
                                [placeholder]="'PLACEHOLDER.TEXT' | translate"
                                [(ngModel)]="project.applicant_nation"
                            >
                        </div>
                    </div>
                    <!-- 城市 -->
                    <div class="col-6 mb-3">
                        <label>{{ "AUTO_DRAW.ENUM.PROJECT_KEY.CITY" | translate }}</label>
                        <div class="d-flex align-items-end">
                            <input 
                                type="text" 
                                class="form-control mr-1" 
                                [placeholder]="'PLACEHOLDER.TEXT' | translate"
                                [(ngModel)]="project.applicant_city"
                            >
                        </div>
                    </div>
                    <!-- 地址 -->
                    <div class="col-12 mb-3">
                        <label>{{ "AUTO_DRAW.ENUM.PROJECT_KEY.ADDRESS" | translate }}</label>
                        <div class="d-flex align-items-end">
                            <input 
                                type="text" 
                                class="form-control mr-1" 
                                [placeholder]="'PLACEHOLDER.TEXT' | translate"
                                [(ngModel)]="project.applicant_address"
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    mat-raised-button color="primary"
                    (click)="submitContact()"
                >
                    {{"BUTTON.SUBBMIT" | translate}}
                </button>
            </div>
        </div>
    </div>
</div>